import { createContext } from 'react';

import type { Locale } from './locales';
import { DEFAULT_LOCALE } from './locales';
import type { TranslationKey } from './translations';

export interface I18nContextValue {
    locale: Locale;
    setLocale: (locale: Locale) => void;
    t: (key: TranslationKey) => string;
}

export const I18nContext = createContext<I18nContextValue>({
    locale: DEFAULT_LOCALE,
    setLocale: () => {},
    t: (key) => key,
});
